import { MenuItem } from "@mui/material";
import React, { useEffect, useState } from "react";
import { ClientApi } from "../../services/ClientApi";
import { EngagementApi } from "../../services/EngagementApi";
import { useAxios } from "../../contexts/AxiosProvider";
import { useSnackbar } from "notistack";
import { Select } from "antd";

const FilterWorkflow = ({ user_id, filterState, setFilterState }) => {
  const axios = useAxios();
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setloading] = useState(false);
  const [clientData, setClientData] = useState({
    clientList: [],
    totalClients: 0,
  });
  const [engagementData, setEngagementData] = useState({
    engagementList: [],
    totalEngagements: 0,
  });

  const fetchAllClients = async () => {
    try {
      setloading(true);
      const data = {
        user_id: user_id,
        domain: false,
        domain_id: "",
        search: false,
        searchParam: "",
        pageNumber: 0,
        pageSize: 0,
      };
      const response = await ClientApi.getAllClients(axios, data);
      if (response.status === 200) {
        setClientData(response.data);
      }
    } catch (error) {
      if (error.response?.status === 500) {
        enqueueSnackbar("500 Internal Server Error!", {
          variant: "error",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
      }
    } finally {
      setloading(true);
    }
  };

  useEffect(() => {
    fetchAllClients();
  }, []);

  const fetchAllEngagements = async (client_id) => {
    try {
      setloading(true);
      const data = {
        user_id: user_id,
        client: true,
        client_id: client_id,
        search: false,
        searchParam: "",
        pageNumber: 0,
        pageSize: 0,
      };
      const response = await EngagementApi.getAllEngagements(axios, data);
      if (response.status === 200) {
        setEngagementData(response.data);
      }
    } catch (error) {
      if (error.response?.status === 500) {
        enqueueSnackbar("500 Internal Server Error!", {
          variant: "error",
          autoHideDuration: 3000,
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
      }
    } finally {
      setloading(false);
    }
  };

  useEffect(() => {
    fetchAllEngagements(filterState.client_id);
  }, [filterState.client_id]);

  const onFilterClient = async (info, e) => {
    if (info !== undefined) {
      setFilterState({
        ...filterState,
        client: true,
        client_name: e.label,
        client_id:
          clientData.clientList.find((item) => item.client_name === e.label)
            ?.client_id || "",
      });
    } else {
      setFilterState({
        ...filterState,
        client: false,
        client_name: "",
        client_id: "",
        engagement: false,
        engagement_name: "",
        engagement_id: "",
      });
    }
  };

  const onFilterEngagement = async (info, e) => {
    setFilterState({
      ...filterState,
      engagement: info === undefined ? false : true,
      engagement_name: info === undefined ? "" : e.label,
      engagement_id:
        info === undefined
          ? ""
          : engagementData.engagementList.find(
              (item) => item.engagement_name === e.label
            )?.engagement_id || "",
    });
  };
  return (
    <div style={{ display: "flex" }}>
      <Select
        placeholder="Filter By Sub-Function"
        style={{ width: 200, marginRight: 5 }}
        size="large"
        allowClear
        onClear={onFilterClient}
        onSelect={onFilterClient}
        options={clientData.clientList
          ?.filter((item) => item.status === "approved")
          .map((item) => ({
            value: item.client_id,
            label: item.client_name,
          }))}
      />
      {filterState.client_name && (
        <Select
          placeholder="Filter By Pipeline"
          style={{ width: 200, marginRight: 5 }}
          size="large"
          allowClear
          onClear={onFilterEngagement}
          onSelect={onFilterEngagement}
          options={engagementData.engagementList
            ?.filter((item) => item.status === "approved")
            .map((item) => ({
              value: item.engagement_id,
              label: item.engagement_name,
            }))}
        />
      )}
    </div>
  );
};

export default FilterWorkflow;
